import {
  Box,
  Flex,
  FlexProps,
  Link,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import { useCopyToClipboard } from "usehooks-ts";
import { useCurrentPlatform } from "~/api/resources";
import { Facebook, Instagram, Share, Twitter } from "~/images/svgs";
import { NewsletterIconButton } from "~/providers";

const normalizeHttpUrl = (value?: string) => {
  if (!value?.trim()) return undefined;
  const trimmed = value.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export const SocialIconsNav = (props: FlexProps) => {
  const { data: platform } = useCurrentPlatform();
  const share = useShare();
  const size = 6;
  const getIcon = (social: string) => {
    switch (social) {
      case "Facebook":
        return Facebook;
      case "Twitter":
      case "X":
      case "X (formerly Twitter)":
        return Twitter;
      case "Instagram":
        return Instagram;
      default:
        return false;
    }
  };
  return (
    <Flex alignItems="flex-end" gap={6} {...props}>
      {platform?.links?.map((sm) => {
        const Icon = getIcon(sm.key);
        const href = normalizeHttpUrl(sm.value);
        if (!Icon || !href) return null;
        return (
          <Tooltip key={sm.key} label={`Go to ${sm.key}`}>
            <Link href={href} target="_blank" rel="noopener noreferrer" color="gray.900">
              <Icon boxSize={size} />
            </Link>
          </Tooltip>
        );
      })}
      <Box display={"flex"} style={{ margin: -3 }}>
        <NewsletterIconButton />
      </Box>
      <Tooltip label="Copy link">
        <Link
          color="gray.900"
          onClick={() => {
            share({ url: document.location.href });
          }}
        >
          <Share boxSize={size} />
        </Link>
      </Tooltip>
    </Flex>
  );
};

const useShare = () => {
  const [value, copy] = useCopyToClipboard();
  const toast = useToast();
  const share = async (data: ShareData & { url: string }) => {
    if (!!navigator.share && !!navigator.canShare && navigator.canShare(data)) {
      navigator.share(data).then(
        () => { },
        (e) => {
          console.warn(e);
        }
      );
    } else {
      copy(data.url).then((success) => {
        toast({
          title: success
            ? "Share link copied to clipboard."
            : "Failed to copy to clipboard.",
          description: "",
          position: "top",
          colorScheme: success ? "sage" : "red",
        });
      });
    }
  };
  return share;
};
